import { useEffect } from "react";

const DishwasherRepair = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#222222] text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {/* Image container with mobile optimization */}
        <div className="h-[40vh] md:h-screen relative">
          <img
            src="/lovable-uploads/2d164f8f-316d-4105-b0a9-18b101fdb2fc.png"
            alt="Dishwasher repair service"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 overflow-y-auto">
          <h1 className="text-4xl font-bold mb-8 text-accent">Dishwasher Repair Services</h1>
          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-accent-light mb-4">Expert Dishwasher Repair in GTA</h2>
              <p className="text-gray-300 mb-4">
                Our skilled technicians provide comprehensive dishwasher repair services for all makes and models.
                We ensure your dishwasher returns to optimal performance quickly and efficiently.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Our Repair Services:</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Drainage system repairs</li>
                <li>Pump and motor replacement</li>
                <li>Water inlet valve repairs</li>
                <li>Spray arm maintenance</li>
                <li>Control board diagnostics</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Why Trust Us?</h3>
              <ul className="space-y-4 text-gray-300">
                <li>✓ Experienced technicians</li>
                <li>✓ Same-day service</li>
                <li>✓ Genuine replacement parts</li>
                <li>✓ Competitive pricing</li>
                <li>✓ Satisfaction guaranteed</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Common Issues We Fix</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-300">
                <div>• Not draining properly</div>
                <div>• Leaking water</div>
                <div>• Not cleaning well</div>
                <div>• Strange noises</div>
                <div>• Door problems</div>
                <div>• Control panel issues</div>
              </div>
            </section>

            <div className="mt-8">
              <a
                href="tel:416-805-5075"
                className="bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-lg inline-block transition-colors"
              >
                Call Now for Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DishwasherRepair;
